<template>
  <div class="form-group">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'FormGroup',
  components: {},
  props: {},
  mounted () {},
  data: () => ({})
}
</script>

<style lang="scss">
    @import "./form-group";
</style>



// WEBPACK FOOTER //
// src/components/Form/FormGroup/form-group.vue